var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c(
        "div",
        {
          staticClass: "myskov-order-block",
          class: { "myskov-order-block--print": _vm.printOrder }
        },
        [
          _c(
            "div",
            { staticClass: "myskov-order-block__header" },
            [
              _c("hotel-block-header", {
                attrs: {
                  hotel: _vm.hotelHeader,
                  "order-number": _vm.order.bookingCode,
                  "show-favorite": false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "agency-block agency-block--verified agency-block--status-OK"
            },
            [
              _vm.tourOperator
                ? _c("div", { staticClass: "agency-block__header" }, [
                    _c("div", { staticClass: "agency-block__header__name" }, [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.translations.title)
                        }
                      }),
                      _vm._v(" "),
                      _c("h2", {
                        domProps: { textContent: _vm._s(_vm.tourOperator.name) }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.translations.trip_to)
                        }
                      }),
                      _vm._v(" "),
                      _vm.hotel && _vm.hotel.location
                        ? _c("h2", {
                            domProps: {
                              textContent: _vm._s(_vm.hotel.location.name)
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "agency-block__header__logo" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.tourOperator.logo,
                          alt: _vm.tourOperator.name
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.outboundFlight || _vm.inboundFlight
                ? _c(
                    "div",
                    { staticClass: "travel-block-grid" },
                    [
                      _vm.outboundFlight
                        ? _c("travel-block", {
                            attrs: {
                              title: _vm.translations.travel_out,
                              "flight-data": _vm.outboundFlight
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.inboundFlight
                        ? _c("travel-block", {
                            attrs: {
                              title: _vm.translations.travel_home,
                              "flight-data": _vm.inboundFlight
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "agency-block__travel-disclaimer",
                  domProps: { textContent: _vm._s(_vm.translations.notice) }
                },
                [_vm._v("Med forbehold for flytidsændringer")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "order-travelers" }, [
                _c("div", { staticClass: "order-travelers__header" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.translations.travellers) +
                        " " +
                        _vm._s(_vm.numberOfTravelers)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "order-travelers__grid" },
                  _vm._l(_vm.travelllers, function(traveller, travellerKey) {
                    return _c("traveller", {
                      key: travellerKey,
                      attrs: { traveller: traveller, number: travellerKey + 1 }
                    })
                  })
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "agency-block__priced-included-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "included-item-grid" },
                    [
                      _vm.packageOffer && _vm.packageOffer.transferIncluded
                        ? _c("included-item", {
                            attrs: {
                              title:
                                _vm.translations.includes.transfer_included,
                              "icon-type": "transfer"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.packageOffer && !_vm.packageOffer.transferIncluded
                        ? _c("included-item", {
                            attrs: {
                              title:
                                _vm.translations.includes.transfer_not_included,
                              "icon-type": "transfer"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("included-item", {
                        attrs: {
                          title: _vm.translations.includes.loggage_included,
                          "icon-type": "baggage"
                        }
                      }),
                      _vm._v(" "),
                      _vm.originalRoomtypeName
                        ? _c("included-item", {
                            attrs: {
                              title: _vm.originalRoomtypeName,
                              translatedTitle: _vm.translatedRoomTypeName,
                              "icon-type": "hotel",
                              translatable: "true"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hotelOffer && _vm.hotelOffer.boardType
                        ? _c("included-item", {
                            attrs: {
                              title: _vm.hotelOffer.boardType.name,
                              "icon-type": "food"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("included-item", {
                        attrs: {
                          title: _vm.translations.includes.flight_class,
                          "icon-type": "flightclass"
                        }
                      }),
                      _vm._v(" "),
                      _vm.bookingInformation &&
                      _vm.bookingInformation.accommodatesDisabledGuests
                        ? _c("included-item", {
                            attrs: {
                              title: _vm.translations.includes.handicap,
                              "icon-type": "handicap"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.bookingInformation &&
                      !_vm.bookingInformation.accommodatesDisabledGuests
                        ? _c("included-item", {
                            attrs: {
                              title: _vm.translations.includes.not_handicap,
                              "icon-type": "noHandicap"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.totalPrice
                    ? _c("total-price", {
                        attrs: {
                          totalPrice: _vm.totalPrice.value,
                          currency: _vm.totalPrice.currency
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "agency-block__actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn--travel-description",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.onPrint }
                  },
                  [
                    _c("span", {
                      staticClass: "btn__text",
                      domProps: {
                        textContent: _vm._s(_vm.translations.print_btn)
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--positive",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.onContact }
                  },
                  [
                    _c("span", {
                      staticClass: "btn__text",
                      domProps: {
                        textContent: _vm._s(_vm.translations.contact_btn)
                      }
                    })
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ec8ce72", { render: render, staticRenderFns: staticRenderFns })
  }
}